import { useMemo, useState } from "react";
import {
  List,
  NumberField,
  TextField,
  WrapperField,
  DatagridConfigurable,
  WithRecord,
  BulkDeleteWithConfirmButton,
  usePermissions,
} from "react-admin";
import SizePriceAdditionAddDialog from "../../components/sizePriceAdditions/create/SizePriceAdditionAddDialog";
import SizePriceAdditionEditDialog from "../../components/sizePriceAdditions/edit/SizePriceAdditionEditDialog";
import sizePriceAdditionFilterList from "../../components/sizePriceAdditions/filter/sizePriceAdditionFilterList";
import EditBtn from "../../components/editBtn/EditBtn";
import TableListActions from "../../components/tableListActions/TableListActions";

const SizePriceAdditionList = () => {
  const { permissions } = usePermissions();
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [recordId, setRecordId] = useState();

  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };
  const handleClickOpenEdit = (recId) => () => {
    setRecordId(recId);
    setOpenEdit(true);
  };
  const list = useMemo(
    () => (
      <List
        empty={false}
        actions={
          <TableListActions
            createHandler={handleClickOpenAdd}
            exporter={false}
          />
        }
        filters={sizePriceAdditionFilterList(permissions)}
        queryOptions={{ meta: { sort: ["price ASC"] } }} // overide default sort
      >
        <DatagridConfigurable
          bulkActionButtons={<BulkDeleteWithConfirmButton />}
        >
          {permissions && permissions.update_company ? (
            <TextField label="mine.label.company" source="company.alias" />
          ) : null}
          <TextField source="size.name" label="mine.label.size" />
          <NumberField source="price" label="mine.label.price" />
          <WrapperField label="mine.label.actions" textAlign="center">
            <WithRecord
              label="author"
              render={(record) => {
                return <EditBtn editHandler={handleClickOpenEdit(record.id)} />;
              }}
            />
          </WrapperField>
        </DatagridConfigurable>
      </List>
    ),
    [permissions]
  );
  return (
    <>
      {list}
      <SizePriceAdditionAddDialog open={openAdd} setOpen={setOpenAdd} />
      <SizePriceAdditionEditDialog
        open={openEdit}
        setOpen={setOpenEdit}
        recordId={recordId}
      />
    </>
  );
};

export default SizePriceAdditionList;
